// extracted by mini-css-extract-plugin
module.exports = {"timingContainer":"styles_timingContainer__2xSSq","contentFrame":"styles_contentFrame__GSaq6","row":"styles_row__2bt22","screenImg":"styles_screenImg__xPOVn"};